import React, { useEffect, useState } from "react";
// import axios from "axios";
// import { server_api } from "config/config";
import Rules from "./Rules";
import Modal from "@mui/material/Modal";
import EventDetailsBg from "./EventDetailsBg";
import EventsDetailsHeader from "./EventsDetailsHeader";
import Tnc from "components/tnc/Tnc";
// import Comingsoon from "./comingsoon/Comingsoon";
import { FIREBASE_STORAGE_URL, AWS_S3_URL } from "utils/constants";
import { getEventData } from "utils/fetchEvents";

export default function EventDetails({ eventCode, close, registered }) {
  /*
  eventCode --> eventCode to fetch details
  close --> function to close the dialog
  registered --> is the user already registered
  */

  const [loading, setLoading] = useState(true);
  const [event, setEvent] = useState(null);
  // const [imageloaderr, setImageloaderr] = useState(false);

  useEffect(() => {
    /* FETCHING THE DETAILS OF THE EVENTS */
    async function getData() {
      // const res = await axios({
      //   method: "GET",
      //   baseURL: server_api,
      //   url: `events/${eventCode}`,
      // }).catch((err) => {
      //   console.log(err);
      // });
      const res = getEventData(eventCode);
      // console.log(res);

      if (!res?.data?.event) {
        close("force");
      }

      if (res?.data?.success) {
        setEvent(res.data.event);
      }

      setLoading(false);
    }

    // let source = null;
    if (eventCode) {
      // source = axios.CancelToken.source();
      getData();
    }

    // return () => {
    //   /* clean-up */
    //   if (source) source.cancel();
    // };
  }, [eventCode, close]);

  return (
    <Modal open={true}>
      <div className="w-full h-full min-h-screen text-gray-50 py-0 outline-none relative event_details_modal">
        <EventDetailsBg />

        {/* SHOWING "LOADING..." AS THE DATA IS BEEN FETCHED */}
        {loading ? (
          <div className="w-full h-full min-h-screen flex items-center justify-center">
            <p>Loading...</p>
          </div>
        ) : (
          <>
            {event && (
              <>
                <div className="p-1 pb-4 sm:p-8 sm:pt-4 flex flex-col z-10 min-h-screen min-w-screen w-full justify-center">
                  <EventsDetailsHeader
                    event={event}
                    registered={registered}
                    close={close}
                  />

                  <div className="flex px-5 event_details grow">
                    <div className="flex justify-center event_img_container px-8 py-4">
                      {/* <img
                          alt=""
                          src={"/images/mobile.png"}
                          className="w-full z-10"
                        /> */}
                      {/* {!imageloaderr && (
                        <img
                          src={`https://edge-results.s3.ap-south-1.amazonaws.com/events/${event._id}.jpg`}
                          alt=""
                          className="z-10 max-h-[75vh] h-auto max-w-full max event-poster-img"
                          onError={() => setImageloaderr(true)}
                        />
                      )} */}
                      {/* {imageloaderr && <Comingsoon />} */}

                      <img
                        src={`${FIREBASE_STORAGE_URL}edge2k22_posters%2F${event.poster}.jpg?alt=media`}
                        alt={event.title || ""}
                        className="z-10 max-h-[75vh] h-auto max-w-full max event-poster-img"
                        onError={(e) => onImageLoadErrorHandler(e, event._id)}
                      />
                    </div>

                    <div className="grow">
                      <div className="z-10">
                        <div className="flex flex-col pb-5 text-center relative z-10">
                          <h3 className="text-2xl event_glitch_sub text-red-300">
                            {event.subtitle}
                          </h3>
                          {/* <h3 className="-ml-14 text-2xl glitch_txt">{event.subtitle}</h3> */}
                          <h1 className="text-5xl event_glitch_title pt-4 text-red-300">
                            {event.title}
                          </h1>
                          {/* <h1 className="-mr-36 text-5xl glitch_txt">{event.title}</h1> */}
                        </div>

                        <div className="flex justify-evenly z-10 ">
                          <div className=" w-full text-justify event_details_text z-10 text-red-300">
                            <p>{event.desc}</p>
                            <Rules data={event.rules} />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="bg-[#7f0600] m-0 px-8 sm:fixed sm:bottom-0 py-3 flex w-full items-center justify-center z-10 text-center event_details_contact">
                  For Queries, please contact:
                  <div className="flex flex-col md:flex-row">
                    {event?.contacts &&
                      event.contacts.map((e, _idx) => {
                        return <ContactCard key={_idx.toString()} data={e} />;
                      })}

                    <Tnc />
                  </div>
                </div>
              </>
            )}
          </>
        )}
      </div>
    </Modal>
  );
}

function ContactCard(props) {
  return (
    <div className="px-4 flex justify-center">
      <p className="px-2">{props.data.name}</p>
      <p className="px-2">{props.data.number}</p>
    </div>
  );
}

const onImageLoadErrorHandler = (event, id) => {
  if (event) event.target.src = `${AWS_S3_URL}events/${id}.jpg`;
};
